import {createFileRoute} from '@tanstack/react-router';

import {EditProjectPage} from '@/modules/projects/pages/EditProjectPage';

const RouteComponent = () => {
  const {projectId} = Route.useParams();
  return <EditProjectPage projectId={projectId} />;
};

export const Route = createFileRoute('/_authenticated/projects/$projectId_/edit')({
  component: RouteComponent,
});
